export var DocsPageHeaderType;
(function (DocsPageHeaderType) {
    DocsPageHeaderType[DocsPageHeaderType["HEADING_1"] = 0] = "HEADING_1";
    DocsPageHeaderType[DocsPageHeaderType["HEADING_2"] = 1] = "HEADING_2";
    DocsPageHeaderType[DocsPageHeaderType["HEADING_3"] = 2] = "HEADING_3";
    DocsPageHeaderType[DocsPageHeaderType["HEADING_4"] = 3] = "HEADING_4";
    DocsPageHeaderType[DocsPageHeaderType["HEADING_5"] = 4] = "HEADING_5";
})(DocsPageHeaderType || (DocsPageHeaderType = {}));
//# sourceMappingURL=DocsPageHeaderType.js.map